<template>
  <div>
    <button class="button is-gray flex-align" style="width: auto; gap: 0 10px" @click="clickOpenModal">
      <div v-if="conversion && conversion.after" class="flex-align" style="gap: 0 10px">
        <div class="size-13 weight-400 main">{{ conversion.after.label }} <strong>{{ conversion.after.count }}</strong>건</div>
        <div class="divider"></div>
      </div>
      <div class="flex-align primary" style="gap: 0 4px">
        <div class="size-13 weight-400">주문 퍼포먼스 정보</div>
        <i class="material-icons" style="font-size: 16px">keyboard_arrow_right</i>
      </div>
    </button>
    <modal-product-order-performance ref="productOrderPerformanceModal"
      :prod="prod" :performance="performance"
      :productType="productType"
      :conversion="conversion"
      :disabled="disabled"></modal-product-order-performance>
  </div>
</template>

<script>
  import ModalProductOrderPerformance from "./ModalProductOrderPerformance";

  export default {
    name: 'BtnProductOrderPerformance',
    components: {
      ModalProductOrderPerformance
    },
    props: {
      prod: {
        type: Object
      },
      performance: {
        type: Object
      },
      disabled: {
        type: Boolean
      },
      conversion: {
        type: Object
      },
      productType: {
        type: String
      }
    },
    methods: {
      clickOpenModal() {
        setTimeout(()=> {
          this.$refs.productOrderPerformanceModal.open();
        }, 100);
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-price-schedule-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .grid-schedule
    display grid
    grid-template-columns 60px 80px 80px 200px 100px 150px 120px
    grid-gap 20px
    align-items center

  .divider
    width 100%
    height 1px
    background-color #eeeeee
    margin 12px 0

  .grid-title
    font-size 14px

  .divider
    width 1px
    background-color #cccccc
    height 18px

</style>
<style lang="stylus">
  .product-order-performance-container
    .sweet-modal.is-alert
      width 974px
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>